import { useCallback, useState } from "react";
import { useModal, useTermsAgreeMutation } from "@/hooks";
import TermAgreementForm from "@/components/Form/TermAgreementForm";

export default function TermsAgreementModal({ terms }) {
  const { hideModal } = useModal();
  const [agreementError, setAgreementError] = useState();
  const [agree] = useTermsAgreeMutation({
    onCompleted: () => {
      hideModal();
    },
    onError: (e) => {
      setAgreementError(e.message);
    },
  });

  const onSubmit = useCallback(
    (data) => {
      if (data.terms) {
      }
      const keys = terms
        .filter((term) => {
          if (data.terms && term.required) {
            return true;
          } else if (data.termsMail && term.id_key === "spoox_mail") {
            return true;
          } else {
            return false;
          }
        })
        .map((term) => term.current_revision.unique_key);
      agree({ variables: { keys } });
    },
    [terms]
  );

  return (
    <TermAgreementForm
      onSubmit={onSubmit}
      terms={terms}
      agreementError={agreementError}
    />
  );
}
